export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";